export default "__VITE_ASSET__97193318__"